import { HubspotForm } from "@/features/tracking";
import { DetailedHTMLProps, HTMLAttributes } from "react";
import type { Props } from "../types";
import styles from "./index.module.scss";
import { Airtable } from "./services/Airtable";
import { MetabaseDashboard } from "./services/MetabaseDashboard";
import { MetabaseGuestEmbed } from "./services/MetabaseGuestEmbed";
import { Scribe } from "./services/Scribe";
import { YouTube } from "./services/YouTube";
type DivProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
interface EmbedProps extends DivProps {
  data: Props;
}
export const Embed = ({
  data,
  ...props
}: EmbedProps) => {
  return <div className={styles.container} {...props} data-sentry-component="Embed" data-sentry-source-file="index.tsx">
      {getComponent(data)}
    </div>;
};
const getComponent = (data: Props) => {
  switch (data.type) {
    case "airtable":
      return <Airtable {...data} />;
    case "hubspotForm":
      return <HubspotForm {...data} />;
    case "metabaseDashboard":
      return <MetabaseDashboard {...data} />;
    case "metabaseGuestEmbed":
      return <MetabaseGuestEmbed {...data} />;
    case "scribe":
      return <Scribe {...data} />;
    case "youtube":
      return <YouTube {...data} />;
  }
};